<template>
  <div style="width: 100%" class="fill-height">
    <v-row class="pt-3 pr-3">
      <v-spacer></v-spacer>
      <Search-box
        :emitDestination="searchEmitDestination"
        searchPlaceholder="Pretraži artikle"
      ></Search-box>
    </v-row>
    <v-container>
      <v-row
        v-if="listView"
        style="margin-top: 0px"
        class="d-flex justify-center"
      >
        <v-col cols="12" sm="11" lg="11" :class="['px-0']">
          <div class="wh-simple-rows-body">
            <v-card v-for="(item, i) in items" :key="i"
              :class="['wh-simple-card', getStatusClass(item)]">
              <v-row class="ma-0 align-center" style="min-height: 60px;">
                <div v-if="density !== 'greater'" style="padding: 8px 12px; flex-shrink: 0;">
                  <v-img v-if="item.picture" :src="item.picture" contain width="44" height="44" style="border-radius: 6px;"></v-img>
                  <div v-else style="width: 44px; height: 44px; border-radius: 6px; background: #F1F5F9;"></div>
                </div>
                <div style="flex-grow: 1; min-width: 0; padding: 8px 16px;">
                  <div class="wh-simple-name one-liner-text">{{ $options.filters.capitalize(item.name) }}</div>
                </div>
                <div class="hidden-sm-and-down" style="width: 15%; padding: 8px 16px;">
                  <div class="wh-simple-cell">{{ item.code }}</div>
                </div>
                <div style="width: 15%; padding: 8px 16px;">
                  <div class="wh-simple-cell text-right">
                    {{ item.type === 'GOODS' ? item.stock.toString().replace('.', ',') : '—' }}
                  </div>
                </div>
                <div style="width: 110px; padding: 8px 16px;">
                  <v-chip x-small :class="getStatusChipClass(item)">{{ item.status }}</v-chip>
                </div>
                <div style="padding: 8px 8px; flex-shrink: 0;">
                  <v-menu v-if="item.type !== 'SERVICE'" offset-y left>
                    <template #activator="{ on, attrs }">
                      <v-btn icon small v-on="on" v-bind="attrs" :disabled="item.status === 'PROCESSING'">
                        <v-icon size="18" color="#94A3B8">mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list dense class="wh-kebab-list">
                      <v-list-item @click="openEditForm(item)" class="wh-menu-item">
                        <v-icon small color="#3989C9" class="mr-2">mdi-pencil</v-icon>
                        <v-list-item-title class="wh-menu-title wh-menu-edit">Uredi</v-list-item-title>
                      </v-list-item>
                      <v-divider class="my-1"></v-divider>
                      <v-list-item @click="openWhDeleteDialog(item)" class="wh-menu-item">
                        <v-icon small color="#ef4444" class="mr-2">mdi-delete-outline</v-icon>
                        <v-list-item-title class="wh-menu-title wh-menu-delete">Obriši artikl</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <span v-else style="display: inline-block; width: 28px;"></span>
                </div>
              </v-row>
            </v-card>
          </div>
        </v-col>
      </v-row>
      <v-row
        v-else
        class="d-flex justify-center align-center fill-height ma-0 pa-0"
      >
        <v-card
          class="align-center ma-5"
          v-for="(item, i) in items"
          :key="i"
          hover
          height="300"
          width="250"
        >
          <v-img
            height="190"
            width="250"
            v-if="item.picture"
            :src="item.picture"
          >
          </v-img>
          <v-img height="190" width="250" v-else src="@/assets/no-item.jpg">
          </v-img>
          <div class="mr-4 ml-4">
            <div>
              <h3 class="selling-point-title-text one-liner-text">
                {{ $options.filters.capitalize(item.name) }}
              </h3>
              <p class="grey--text mb-1 selling-point-text one-liner-text">
                Status: {{ item.status }}
              </p>
            </div>
          </div>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-on="on"
                  v-bind="attrs"
                  icon
                  :disabled="item.status === 'PROCESSING'"
                  @click="openEditForm(item)"
                  @keypress="openEditForm(item)"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Uredi artikl</span>
            </v-tooltip>
          </v-card-actions>
        </v-card>
      </v-row>
      <infinite-loading
        ref="InfiniteLoading"
        @infinite="infiniteHandler"
        spinner="waveDots"
      >
        <div slot="no-more" class="text--secondary font-italic"></div>
        <div slot="no-results" class="text--secondary font-italic"></div>
      </infinite-loading>
    </v-container>
    <add-warehouse-item
      ref="addWarehouseItem"
      @success="refreshWarehouse"
      @refresh="refresh"
    ></add-warehouse-item>
    <edit-warehouse-item
      ref="editWarehouseItem"
      @success="refreshWarehouse"
      @refresh="refresh"
    ></edit-warehouse-item>

    <v-dialog v-model="whDeleteDialog" max-width="460" @click:outside="whDeleteDialog = false">
      <v-card class="del-modal-card" style="height: 280px; display: flex; flex-direction: column;">
        <div class="del-modal-header">
          <div class="del-modal-header-gloss"></div>
          <div class="del-modal-header-content">
            <v-icon color="white" size="22" class="mr-2">mdi-delete-outline</v-icon>
            <div>
              <div class="del-modal-title">Brisanje artikla</div>
              <div v-if="whItemToDelete" class="del-modal-subtitle">{{ whItemToDelete.name }}</div>
            </div>
            <v-spacer></v-spacer>
            <v-btn icon small @click="whDeleteDialog = false" class="del-modal-close-btn">
              <v-icon color="white" size="20">mdi-close</v-icon>
            </v-btn>
          </div>
        </div>
        <v-card-text class="pt-5 pb-3 px-6" style="flex: 1; overflow-y: auto; min-height: 0;">
          <div v-if="whDeleteLoading" class="d-flex align-center justify-center py-6">
            <v-progress-circular indeterminate color="#3989C9" size="38" width="3"></v-progress-circular>
          </div>
          <div v-else-if="whDeleteError" class="del-info-box del-info-box--error">
            <v-icon size="20" color="#b91c1c" class="mr-3">mdi-alert-circle-outline</v-icon>
            <span>Došlo je do greške. Pokušajte ponovo.</span>
          </div>
          <div v-else class="del-info-box del-info-box--confirm">
            <v-icon size="20" color="#b91c1c" class="mr-3 flex-shrink-0">mdi-alert-remove-outline</v-icon>
            <span>Artikl će biti trajno uklonjen sa skladišta.</span>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pb-5 px-6" style="flex-shrink: 0;">
          <v-spacer></v-spacer>
          <v-btn text class="del-btn-cancel" @click="whDeleteDialog = false">Zatvori</v-btn>
          <v-btn
            v-if="!whDeleteError"
            elevation="0"
            class="del-btn-delete"
            :loading="whDeleteLoading"
            :disabled="whDeleteLoading"
            @click="confirmWhDelete"
          >
            <v-icon small class="mr-2">mdi-delete-outline</v-icon>
            Obriši artikl
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { df } from '@/plugins/firebase'
import state from '@/state'
import addWarehouseItem from '@/modules/point-of-sale/components/AddWarehouseItem'
import editWarehouseItem from '@/modules/point-of-sale/components/EditWarehouseItem'
import InfiniteLoading from 'vue-infinite-loading'
import flow from '@/mixins/flow'
import applicationSettings from '@/mixins/applicationSettings' // don't move.. detaches firebase listeners
import barcodeChecker from '@/mixins/barcodeChecker'
import { collection, query, getDocs, orderBy, where, limit, startAfter } from 'firebase/firestore'
import EventBus from '@/plugins/event-bus'

export default {
  name: 'Warehouse',
  inject: ['showLoader', 'hideLoader'],
  mixins: [flow, applicationSettings, barcodeChecker],
  components: { addWarehouseItem, InfiniteLoading, editWarehouseItem },
  data: () => ({
    dialog: false,
    loading: false,
    totalArticles: 0,
    lastVisible: '',
    lastiItem: false,
    items: [],
    searchEmitDestination: 'simpleWarehouseSearch',
    whDeleteDialog: false,
    whDeleteLoading: false,
    whDeleteError: false,
    whItemToDelete: null
  }),
  computed: {
    listView () {
      return state.isListView()
    },
    search () {
      return state.search
    }
  },
  watch: {
    listView (nv, ov) {
      if (nv !== ov) {
        if (this.$refs.InfiniteLoading) {
          this.$refs.InfiniteLoading.stateChanger.reset()
        }
      }
    }
    // search () {
    //   this.lastVisible = ''
    //   this.items = []
    //   if (this.$refs.InfiniteLoading) {
    //     this.$refs.InfiniteLoading.stateChanger.reset()
    //   }
    // }
  },
  mounted () {
    this.getMultiplier()

    EventBus.$on(this.searchEmitDestination, (searchObject) => {
      if (!searchObject.triGramObject) {
        this.lastDocSnapshot = null
        this.detachListeners()
        this.resetHandler()
      } else {
        this.getItemsNew(searchObject.triGramObject)
      }
    })
  },
  methods: {
    refresh () {
      this.lastDocSnapshot = null
      this.detachListeners()
      this.resetHandler()
    },
    async infiniteHandler ($state) {
      const newItemsCount = await this.getItemsNew()
      if (newItemsCount > 0) {
        return $state.loaded() // getItems je vratio vise od nula artikala, znaci da ih ima jos
      }
      return $state.complete() // getItems je vratio 0 artikala, znaci da ih vise nema
    },

    async getItemsNew (triGramObject = undefined) {
      const searchConstraints = []
      if (triGramObject) {
        Object.keys(triGramObject).forEach(name =>
          searchConstraints.push(where(`meta.${name}`, '==', true))
        )
      }

      if (!triGramObject) {
        searchConstraints.push(orderBy('name', 'asc'))
      }

      if (this.lastDocSnapshot && !triGramObject) {
        searchConstraints.push(startAfter(this.lastDocSnapshot))
      }

      searchConstraints.push(limit(10))

      const constraints = [
        collection(df, `location_warehouse/${state.getPointOfSale().id}/items`),
        ...searchConstraints
      ]

      const q = query.apply(this, constraints)

      const querySnapshot = await getDocs(q)
      this.lastDocSnapshot = querySnapshot.docs[querySnapshot.docs.length - 1]

      const results = []
      querySnapshot.forEach(doc => {
        const d = doc.data()
        d.stock = d.stock / this.multiplier
        d.stock = d.stock.toString().replace('.', ',')
        if (d.prices) {
          Object.keys(d.prices).forEach(key => {
            d.prices[key].currency = key
          })
        }

        results.push({ _id: d.id, ...d })
      })

      if (triGramObject) {
        this.items = results
        this.items = this.items.sort((a, b) => a.name.localeCompare(b.name))
        return true
      }

      this.items.push(...results)
      return results.length
    },
    resetHandler () {
      this.items = []
      if (this.$refs.InfiniteLoading) {
        this.$refs.InfiniteLoading.stateChanger.reset()
      }
    },
    hoverOver (ref, item) {
      const container = this.$refs[ref]
      if (!container || !container[0]) return
      if (container[0].clientHeight < container[0].scrollHeight) {
        item[ref] = true
      }
    },
    openAddWarehouseItemForm () {
      this.$refs.addWarehouseItem.open(this.multiplier)
    },
    openDialog () {
      this.dialog = true
    },
    openEditForm (item) {
      this.$refs.editWarehouseItem.open(item, this.multiplier)
    },
    refreshWarehouse (item) {
      if (item.action === 'ADD') {
        this.items.unshift(
          { ...item, ...{ status: 'PROCESSING' } }
        )
        this.$vuetify.goTo(0)
      }

      if (item.action === 'EDIT') {
        df.doc(`location_warehouse/${state.getPointOfSale().id}/items/${item.id}`).update({ status: 'PROCESSING' })
        const idx = this.items.findIndex(it => it?.id === item.id)
        if (idx > -1) {
          this.items[idx].status = 'PROCESSING'
          this.$forceUpdate()
        }
      }

      const listener = df.doc(`location_warehouse/${state.getPointOfSale().id}/items/${item.id}`)
        .onSnapshot(doc => {
          if (doc && doc.data()) {
            var newItem = doc.data()

            if (newItem.status === 'OK') {
              const idx = this.items.findIndex(it => it?.id === item.id)

              if (idx > -1) {
                newItem.stock = newItem.stock / this.multiplier
                this.items[idx] = newItem
              }

              this.$forceUpdate()
            }
          }
        })

      this.listeners.push(listener)

      // if (item.action === 'ADD') {
      //   this.items.unshift({ ...item, ...{ status: 'PROCESSING' } })
      //   this.$vuetify.goTo(0)
      // } else if (item.action === 'EDIT') {
      //   this.items = this.items.map((_item) => {
      //     if (_item.id === item.id) {
      //       _item.name = item.name
      //       _item.status = 'PROCESSING'
      //     }
      //     return _item
      //   })
      // }
    },
    // modifyItems (change) {
    //   if (change.type === 'added') {
    //     if (
    //       this.items.some(
    //         (item) =>
    //           item.id === change.doc.data().id ||
    //           (item.name.toLowerCase() === change.doc.data().name &&
    //             item.status === 'PROCESSING')
    //       )
    //     ) {
    //       this.items = this.items.map((item) => {
    //         let ret = item
    //         if (
    //           item.id === change.doc.data().id ||
    //           (item.name === change.doc.data().name.toLowerCase() &&
    //             item.status === 'PROCESSING')
    //         ) {
    //           ret = change.doc.data()
    //           ret.stock = ret.stock / this.multiplier
    //         }
    //         return { ...ret, ...{ [`hover-${change.doc.data().id}`]: false } }
    //       })
    //     } else {
    //       const item = change.doc.data()
    //       item.stock = item.stock / this.multiplier
    //       this.items.push({
    //         ...item,
    //         ...{ [`hover-${item.id}`]: false }
    //       })
    //     }
    //   }
    //   if (change.type === 'modified') {
    //     this.items = this.items.map((item) => {
    //       let ret = item
    //       if (item.id === change.doc.data().id) {
    //         ret = change.doc.data()
    //         ret.stock = ret.stock / this.multiplier
    //       }
    //       return { ...ret, ...{ [`hover-${change.doc.data().id}`]: false } }
    //     })
    //   }
    // },
    // infiniteHandler ($state) {
    //   const that = this

    //   let search = 'name'
    //   if (this.isBarcodeSearch(this.search)) {
    //     search = 'barcode'
    //   }

    //   const where = that.search ? that.search.toLowerCase() : ''
    //   let query = df
    //     .collection(`location_warehouse/${state.getPointOfSale().id}/items`)
    //     .orderBy(search, 'asc')
    //     .limit(10)
    //     .startAfter(that.lastVisible)

    //   if (where) {
    //     query = query
    //       .where(search, '>=', where)
    //       .where(search, '<=', where + '\uf8ff')
    //   }

    //   const listener = query.onSnapshot(
    //     (doc) => {
    //       doc.docChanges().forEach((change) => {
    //         that.modifyItems(change)
    //       })
    //       if (doc && !doc.empty) {
    //         if (doc.docs[doc.docs.length - 1]) {
    //           that.lastVisible = doc.docs[doc.docs.length - 1]
    //         }
    //         $state.loaded()
    //       } else {
    //         $state.complete()
    //       }
    //     }
    //     // (error) => {
    //     //   console.log('error', error)
    //     // }
    //   )

    //   this.listeners.push(listener)
    // },
    getMultiplier () {
      const listener = df.doc('project_constants/config').onSnapshot(doc => {
        this.config = doc.data()
        this.multiplier = doc.data().item_amount.decimal_multiplier
      })
      this.listeners.push(listener)
    },
    getStatusClass (item) {
      if (item.status === 'OK') return 'wh-status-ok'
      if (item.status === 'PROCESSING') return 'wh-status-warn'
      return 'wh-status-failed'
    },
    getStatusChipClass (item) {
      if (item.status === 'OK') return 'wh-chip-ok'
      if (item.status === 'PROCESSING') return 'wh-chip-warn'
      return 'wh-chip-failed'
    },

    openWhDeleteDialog (item) {
      this.whItemToDelete = item
      this.whDeleteError = false
      this.whDeleteDialog = true
    },

    async confirmWhDelete () {
      if (!this.whItemToDelete) return
      this.whDeleteLoading = true
      try {
        const locId = state.getPointOfSale().id
        await df.doc(`location_warehouse/${locId}/items/${this.whItemToDelete.id}`).delete()
        this.items = this.items.filter(i => i.id !== this.whItemToDelete.id)
        this.whDeleteDialog = false
        this.whItemToDelete = null
      } catch (e) {
        console.error('Greška pri brisanju artikla:', e)
        this.whDeleteError = true
      } finally {
        this.whDeleteLoading = false
      }
    }
  }
}
</script>
<style scoped>
.wh-simple-rows-body {
  background: #F5F7FA;
  padding: 6px 0 2px;
}

.wh-simple-card {
  border: 1px solid #EEF2F5 !important;
  border-left: 3px solid #E0E0E0 !important;
  border-radius: 6px !important;
  background: #ffffff !important;
  box-shadow: none !important;
  overflow: hidden !important;
  margin-bottom: 4px !important;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.wh-simple-card:hover {
  border-color: #00BCD4 !important;
  background: #F8FAFB !important;
}

.wh-simple-card.wh-status-ok     { border-left-color: #4ADE80 !important; }
.wh-simple-card.wh-status-warn   { border-left-color: #FBBF24 !important; }
.wh-simple-card.wh-status-failed { border-left-color: #F87171 !important; }

.wh-simple-name {
  font-size: 15px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.87);
}

.wh-simple-cell {
  font-size: 15px;
  color: rgba(0, 0, 0, 0.87);
}

.wh-chip-ok     { background-color: #DCFCE7 !important; color: #166534 !important; }
.wh-chip-warn   { background-color: #FEF9C3 !important; color: #854D0E !important; }
.wh-chip-failed { background-color: #FEE2E2 !important; color: #991B1B   !important; }

/* ── Kebab menu ────────────────────────────────────────────── */
.wh-kebab-list  { padding: 4px 0 !important; min-width: 150px !important; }
.wh-menu-item   { min-height: 36px !important; padding: 0 12px !important; }
.wh-menu-item >>> .v-list-item__content { padding: 0 !important; display: flex !important; align-items: center !important; }
.wh-menu-title  { font-size: 13px !important; font-weight: 500 !important; line-height: 1 !important; }
.wh-menu-edit   { color: #3989C9 !important; }
.wh-menu-delete { color: #ef4444 !important; }

/* ── Delete modal ──────────────────────────────────────────── */
.del-modal-card { border-radius: 16px !important; overflow: hidden !important; border: 1px solid rgba(0,179,190,0.15) !important; box-shadow: 0 8px 32px rgba(0,0,0,0.14) !important; }
.del-modal-header { position: relative; padding: 20px 24px; background: linear-gradient(135deg, rgba(0,179,190,0.55) 0%, rgba(57,137,201,0.5) 50%, rgba(97,84,164,0.55) 100%); overflow: hidden; }
.del-modal-header-gloss { position: absolute; top: 0; left: -100%; width: 60%; height: 100%; background: linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.18) 50%, transparent 100%); pointer-events: none; }
.del-modal-header-content { position: relative; z-index: 1; display: flex; align-items: center; }
.del-modal-title   { color: white !important; font-weight: 700 !important; font-size: 16px !important; letter-spacing: 0.3px; text-shadow: 0 1px 4px rgba(0,0,0,0.15); line-height: 1.3; }
.del-modal-subtitle { color: rgba(255,255,255,0.8) !important; font-size: 12px !important; font-weight: 500 !important; margin-top: 2px; }
.del-modal-close-btn { background: rgba(255,255,255,0.15) !important; }
.del-modal-close-btn:hover { background: rgba(255,255,255,0.25) !important; }
.del-info-box { display: flex; align-items: flex-start; padding: 14px 16px; border-radius: 10px; font-size: 14px; line-height: 1.5; }
.del-info-box--error   { background: #fff1f2; border: 1px solid #fecdd3; color: #7f1d1d; }
.del-info-box--confirm { background: #fff1f2; border: 1px solid #fecdd3; color: #7f1d1d; }
.del-btn-cancel { color: #3989C9 !important; font-weight: 600 !important; font-size: 14px !important; text-transform: none !important; border-radius: 10px !important; height: 42px !important; padding: 0 18px !important; }
.del-btn-delete { background: linear-gradient(135deg, #f43f5e 0%, #dc2626 100%) !important; color: white !important; border-radius: 10px !important; height: 42px !important; padding: 0 22px !important; font-weight: 600 !important; font-size: 14px !important; text-transform: none !important; box-shadow: 0 4px 12px rgba(220,38,38,0.3) !important; }
</style>
